import React from 'react';

import { FileUploadTypes } from 'api/types/shared.types';
import FilePicker from 'components/FilePicker';

import Field from './Field';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const FileUploadField = ({
  'data-qa-id': qaId,
  description,
  downloadAttachment,
  extraAnalyticsData,
  fileType = 'CMS_UPLOAD',
  hideRemove,
  label,
  large,
  name,
  onError,
  onUpdateValue,
  ...props
}: {
  'aria-label'?: string;
  'data-qa-id'?: string;
  accept?: string;
  description?: string;
  disabled?: boolean;
  downloadAttachment?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraAnalyticsData?: Record<string, any>;
  fileType?: FileUploadTypes;
  hideRemove?: boolean;
  label?: string;
  large?: boolean;
  message?: string;
  name: string;
  onError?: (arg0: Error) => void;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onUpdateValue?: (...args: Array<any>) => any;
  showDate?: boolean;
}) => (
  <Field
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    name={name}
    label={label}
    description={description}
    inputProps={props}
    renderInput={({ value, qaId: autoQaId, updateValue }) => (
      <FilePicker
        downloadAttachment={downloadAttachment}
        extraAnalyticsData={extraAnalyticsData}
        hideRemove={hideRemove}
        fileId={value}
        fileType={fileType}
        value={value || ''}
        data-qa-id={qaId || autoQaId}
        onChange={(e) => {
          if (onUpdateValue) {
            onUpdateValue(e);
          } else {
            updateValue(e);
          }
        }}
        onError={onError}
        name={name}
        large={large}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    )}
  />
);

export default FileUploadField;
